export default __webpack_public_path__ + "static/media/pies_corriendo_con_logo_Dashport.622dd197.jpg";